export type MzMap<K, V> = {
  keys: Array<K>;
  values: Array<V>;
};

export namespace MzMap {
  export function create<K, V>(): MzMap<K, V> {
    return {
      keys: [],
      values: [],
    };
  }

  export function set<K, V>(model: MzMap<K, V>, key: K, value: V): void {
    const index = model.keys.indexOf(key);
    if (index === -1) {
      model.keys.push(key);
      model.values.push(value);
    } else {
      model.values[index] = value;
    }
  }

  export function update<K, V>(model: MzMap<K, V>, key: K, updater: (value: V) => V, notSetValue: V): void {
    const index = model.keys.indexOf(key);
    if (index === -1) {
      model.keys.push(key);
      model.values.push(updater(notSetValue));
    } else {
      model.values[index] = updater(model.values[index]);
    }
  }

  export function updateIfExist<K, V>(model: MzMap<K, V>, key: K, updater: (value: V) => V): void {
    const index = model.keys.indexOf(key);
    if (index > -1) {
      model.values[index] = updater(model.values[index]);
    }
  }

  export function get<K, V>(model: MzMap<K, V>, key: K, notSetValue: V): V {
    const index = model.keys.indexOf(key);
    if (index === -1) {
      return notSetValue;
    }
    return model.values[index];
  }

  export function has<K, V>(model: MzMap<K, V>, key: K): boolean {
    const index = model.keys.indexOf(key);
    if (index === -1) {
      return false;
    }
    return true;
  }

  export function forEach<K, V>(model: MzMap<K, V>, sideEffect: (value: V, key: K, iter: MzMap<K, V>) => void): void {
    model.keys.forEach((key, index) => sideEffect(model.values[index], key, model));
  }

  export function map<K, V>(model: MzMap<K, V>, mapper: (value: V, key: K, iter: MzMap<K, V>) => V): void {
    model.values = model.keys.map((key, index) => mapper(model.values[index], key, model));
  }

  export function values<K, V>(model: MzMap<K, V>): Array<V> {
    return model.values;
  }

  export function size<K, V>(model: MzMap<K, V>): number {
    return model.values.length;
  }
}



// WEBPACK FOOTER //
// ./src/module/Model/MzMap/index.ts